import React from 'react';
import { View } from 'react-native';

import { TypographyHeading, TypographyParagraph, Separator } from '../../../components';
import Text from '../../../components/text/Text';


const ServiceRunWarehouseDetail = ({ servicerun, styles }) => {

	return (
		<>
			<Separator style={styles.separator} />
			<Text style={styles.headerText}>Warehouse</Text>
			<View style={{ ...styles.detailView, flexDirection: 'row', justifyContent: 'flex-start' }}>
				{
					Boolean(servicerun.warehouse?.id) && (
						<>
							<View style={styles.leftItemWidth}>
								<TypographyHeading
									style={{ marginTop: 0 }}
									subheadingSmallSubtle={true}
									label="PICK WAREHOUSE"
								/>
								<TypographyParagraph
									text={servicerun.warehouse?.name || 'Un-named warehouse'}
								/>
							</View>
							<View style={styles.secondButton}>
								<TypographyHeading
									style={{ marginTop: 0 }}
									subheadingSmallSubtle={true}
									label="RETURN WAREHOUSE"
								/>
								<TypographyParagraph
									text={servicerun.returnWarehouse?.name || 'Un-named warehouse'}
								/>
							</View>
						</>
					)
				}
			</View>
		</>
	);
};

export default ServiceRunWarehouseDetail;
